module.exports = __webpack_public_path__ + "static/img/12dungou.5980765.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/12dungou.png
// module id = uvFu
// module chunks = 0